import script from "./AdminMembers.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminMembers.vue?vue&type=script&setup=true&lang=ts"

import "./AdminMembers.vue?vue&type=style&index=0&id=53e50419&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e50419"]])

export default __exports__